import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d307b8fc&"
import script from "@/script.js?vue&type=script&lang=js&"
export * from "@/script.js?vue&type=script&lang=js&"
import style0 from "@/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
